import { lazy } from "react";
import { Navigate } from "react-router-dom";

// Lazy load components for better performance
const Dashboard = lazy(() => import("../Pages/Dashboard"));
const Application = lazy(() => import("../Pages/Application/Application"));

// Lazy load Authentication pages
const Login = lazy(() => import("../Pages/Authentication/Login"));
const ForgetPasswordPage = lazy(() => import("../Pages/Authentication/ForgetPassword"));
const Logout = lazy(() => import("../Pages/Authentication/Logout"));
// const Register = lazy(() => import("../Pages/Authentication/Register"));
const UserProfile = lazy(() => import("../Pages/Authentication/user-profile"));

const authProtectedRoutes = [
  //dashboard
  { path: "/dashboard", component: <Dashboard /> },
  { path: "/application", component: <Application /> },

  // Profile
  { path: "/userprofile", component: <UserProfile /> },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
];

const publicRoutes = [

  // Authentication Page
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPasswordPage /> },
  // Temporarily commented - Registration closed for new applications
  // { path: "/register", component: <Register /> },

];

export { authProtectedRoutes, publicRoutes };
